<template>
  <v-container>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />
    <packing-form />
  </v-container>
</template>

<script>
import PackingForm from './_Form'
export default {
  name: 'AdminMasterPackingEdit',
  components: {
    PackingForm
  },
  mixins: [],
  data () {
    return {
      breadcrumbs: [
        { text: '荷姿一覧', disabled: false, to: '/admin/masters/packings', exact: true },
        { text: '荷姿編集', disabled: true, to: '' },
      ],
    }
  },
  created() {
  },
  methods: {}

}
</script>

<style scoped>

</style>
